import React from 'react';
import GenAiReveal from './GenAiReveal';
import { GEN_AI_CREATIVE_LANDING } from '../../data/genAiCreativeLanding';

const GenAiPains = () => {
  const { pains } = GEN_AI_CREATIVE_LANDING;

  return (
    <section className="bg-[#ecebf2] px-5 py-16 md:px-10 md:py-20 xl:px-[100px] xl:py-[110px]">
      <div className="mx-auto max-w-[1240px]">
        <GenAiReveal>
          <h2 className="max-w-[728px] text-[32px] font-bold leading-none text-[#0b0b0b] md:text-4xl xl:text-[48px]">
            {pains.title}
          </h2>
        </GenAiReveal>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 xl:grid-cols-4 xl:gap-4">
          {pains.items.map((item, index) => (
            <GenAiReveal key={item.id} delay={index * 80}>
              <article className="flex h-full min-h-[240px] flex-col justify-between rounded-3xl bg-white p-7">
                <div className="size-[72px] overflow-hidden rounded-3xl md:size-[90px]">
                  <img
                    src={item.icon}
                    alt=""
                    className="h-full w-full object-cover"
                  />
                </div>
                <h3 className="mt-6 text-xl font-bold leading-[1.1] text-[#0b0b0b] md:text-2xl">
                  {item.text}
                </h3>
              </article>
            </GenAiReveal>
          ))}
        </div>

        <GenAiReveal delay={200} className="mt-5">
          <div className="flex flex-col gap-6 rounded-3xl bg-[#2b7afe] p-8 text-white md:flex-row md:items-center md:justify-between md:gap-10 md:p-12">
            <div className="min-w-0 flex-1">
              <p className="text-base text-[#f3f1f7] md:text-lg">{pains.offer.label}</p>
              <p className="mt-3 text-2xl font-bold leading-snug md:text-[32px]">
                {pains.offer.title}
              </p>
            </div>
            <div className="flex w-full shrink-0 flex-col items-center justify-center rounded-[20px] bg-white px-6 py-5 text-[#2b7afe] sm:w-[180px]">
              <span className="text-4xl font-bold leading-none md:text-5xl">
                {pains.offer.badgeValue}
              </span>
              <span className="mt-1 text-base font-bold md:text-lg">
                {pains.offer.badgeLabel}
              </span>
            </div>
          </div>
        </GenAiReveal>
      </div>
    </section>
  );
};

export default GenAiPains;
